import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebaseConfig';

// NOTE: `occupancyExplanation` was previously being silently dropped from
// this wrapper — not in the signature, not in the payload. Cloud Function
// received undefined → s2.occupy_explanation printed blank on the PDF.
// It is now passed through. Callers should provide it from ElectricalForm
// state (which already saves it to Firestore).
export const generateFormPdf = async (
  formData, panels, overallResult, repairsSummary,
  project, userProfile, reportType, recertType, inspectionDate,
  additionalComments, occupancyExplanation, repairsRequired, repairPermit
) => {
  const functions = getFunctions(app);
  const generateElectricalPdf = httpsCallable(functions, 'generateElectricalPdf');

  const result = await generateElectricalPdf({
    project,
    formData,
    panels,
    overallResult,
    repairsSummary:       repairsSummary       || '',
    additionalComments:   additionalComments   || '',
    occupancyExplanation: occupancyExplanation || '',
    repairsRequired:      typeof repairsRequired === 'boolean' ? repairsRequired : null,
    repairPermit:         repairPermit || '',
    reportType,
    recertType,
    inspectionDate,
    userProfile,
  });

  if (!result.data.success) {
    throw new Error('PDF generation failed');
  }

  const base64 = result.data.pdf;
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  return blob;
};